import React, { useEffect, useState } from 'react';

import * as St from './DevConfiguration.styles';

import { LOOKUP_API_HOST } from '~/api/easy-estimator-api/lookup-retailer-api/lookupRetailerApi.utils';
import { LOCAL_STORAGE_KEY } from '~/core/constants';

interface ConfigurePageProps {
  onClose?: () => void;
}

const DevConfiguration: React.FC<ConfigurePageProps> = ({
  onClose,
}: ConfigurePageProps) => {
  const [formData, setFormData] = useState({
    clientHost: '',
    apiHostname: '',
    companyId: '',
  });

  // Load saved values from localStorage on initial render
  useEffect(() => {
    const savedParams = localStorage.getItem(LOCAL_STORAGE_KEY.LOOKUP_PARAMS);

    if (savedParams) {
      try {
        const parsedParams = JSON.parse(savedParams);

        setFormData({
          clientHost: parsedParams.clientHost || '',
          apiHostname: parsedParams.apiHostname || '',
          companyId: parsedParams.companyId || '',
        });
      } catch (error) {
        console.error('Failed to parse saved retailer params:', error);
      }
    }
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    localStorage.setItem(
      LOCAL_STORAGE_KEY.LOOKUP_PARAMS,
      JSON.stringify(formData)
    );
    if (onClose) {
      onClose();
    }
    // alert('Settings saved to localStorage');
    window.location.reload();
  };

  const handleCancel = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div style={{ margin: '10rem' }} className="dev-retailer-selector">
      <h2>Development Retailer Settings</h2>
      <form onSubmit={handleSubmit}>
        <St.FormGroup>
          <p>
            These are the parameters that will be sent to the{' '}
            <b>{LOOKUP_API_HOST}</b> API, which will return the api server and
            bearer token for retailer specified in the clientHost.
            <br />
          </p>
          <St.FormItemGroup>
            <label htmlFor="clientHost">Client Host:</label>
            <input
              type="text"
              id="clientHost"
              name="clientHost"
              value={formData.clientHost}
              onChange={handleInputChange}
              placeholder="[REQUIRED] What is the client host domain name you're imitating? (e.g. fd.staging.inscyth.com)"
            />
          </St.FormItemGroup>

          <St.FormItemGroup>
            <label htmlFor="apiHostname">API Host:</label>
            <input
              type="text"
              id="apiHostname"
              name="apiHostname"
              value={formData.apiHostname}
              onChange={handleInputChange}
              placeholder="[OPTIONAL] Force a specific API host to be returned. Only necessary for API Server development."
            />
          </St.FormItemGroup>

          <St.FormItemGroup>
            <label htmlFor="companyId">Company ID:</label>
            <input
              type="text"
              id="companyId"
              name="companyId"
              value={formData.companyId}
              onChange={handleInputChange}
              placeholder="[OPTIONAL] Force a specific company ID to be returned. Only necessary for API Server development."
            />
          </St.FormItemGroup>
        </St.FormGroup>

        <St.Button type="submit">Save and Reload</St.Button>
        <St.Button type="button" onClick={handleCancel}>
          Cancel
        </St.Button>
      </form>
    </div>
  );
};

export default DevConfiguration;
